import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  Popover,
  Typography,
} from "@mui/material";
import ShareIcon from "@mui/icons-material/Share";
import CloseIcon from "@mui/icons-material/Close";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import OutlinedInput from "@mui/material/OutlinedInput";

import { classes } from "./share-button.styles";
import { usePopover } from "src/modules/shared/hooks/use-popover/use-popover";
import { CopyToClipboard } from "react-copy-to-clipboard";

import { toast } from "react-toastify";
import {
  EmailShareButton,
  FacebookShareButton,
  TwitterShareButton,
} from "react-share";
import { useContext } from "react";
import { PlayerContext } from "../media-player";

const shareLink = window.location.href;
const title = "ID TAG";

const ShareButton = () => {
  const { anchorEl, open, close, isOpen } = usePopover();

  const { wrapperRef } = useContext(PlayerContext);

  const SharePopup = () => {
    return (
      <Box sx={classes.sharePopup}>
        <Box sx={classes.header}>
          <Typography variant="caption">Share this media</Typography>

          <CloseIcon onClick={close} sx={classes.closeIcon} />
        </Box>

        <Box sx={classes.socials}>
          <EmailShareButton url={shareLink}>
            <IconButton sx={classes.socialIcon} edge="end">
              <MailOutlineIcon />
            </IconButton>
          </EmailShareButton>

          <TwitterShareButton url={shareLink} title={title}>
            <IconButton sx={classes.socialIcon} edge="end">
              <TwitterIcon />
            </IconButton>
          </TwitterShareButton>

          <FacebookShareButton url={shareLink} quote={title}>
            <IconButton sx={classes.socialIcon} edge="end">
              <FacebookIcon />
            </IconButton>
          </FacebookShareButton>
        </Box>

        <OutlinedInput
          sx={classes.input}
          id="outlined-basic"
          value={shareLink}
          endAdornment={
            <InputAdornment position="end">
              <IconButton sx={classes.copyIcon} edge="end">
                <CopyToClipboard
                  text={shareLink}
                  onCopy={() => toast.info("Copied to clipboard")}
                >
                  <ContentCopyOutlinedIcon />
                </CopyToClipboard>
              </IconButton>
            </InputAdornment>
          }
        />
      </Box>
    );
  };

  return (
    <>
      <Button
        sx={classes.shareButton}
        variant="contained"
        onClick={open}
        endIcon={<ShareIcon />}
      >
        Share
      </Button>
      <Popover
        id={"share-options"}
        open={isOpen}
        anchorEl={anchorEl}
        onClose={close}
        container={wrapperRef?.current}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <SharePopup />
      </Popover>
    </>
  );
};

export default ShareButton;
